// Shared semantic color palettes. Keep individual chart hexes pointing at these so the
// product reads with one consistent low→high ramp.

// Five-stop red→green ramp used for any low-to-high tiered visualization: review-rating
// donuts (1★→5★), location completeness levels (Critical→Excellent), and similar.
// Index 0 = worst, index 4 = best.
export const RATING_COLOR_RAMP = ['#FF5853', '#FFA949', '#FFCE4D', '#99D551', '#4CC474'];

// Brand teal. The codebase historically inlines this hex; reach for this constant in new code.
export const BRAND_TEAL = '#416774';
